import React from "react";

interface LateralProgressBarProps {
  progress: number; // expected range: 0 to 100
}

const LateralProgressBar: React.FC<LateralProgressBarProps> = ({
  progress,
}) => {
  return (
    <div className="h-3 w-full overflow-hidden rounded-full bg-[#D3D9DC]">
      <div
        className="h-full rounded-full bg-black transition-[width] duration-700 ease-in-out"
        style={{
          width: `${progress}%`,
          willChange: "width",
        }}
      ></div>
    </div>
  );
};

export default LateralProgressBar;
